import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import Cfg from '../configuration.vue'

import AreaRepository from '@/shared/http/repositories/configuration/area'
import StageRepository from '@/shared/http/repositories/configuration/stage'
import RegulationTypeRepository from '@/shared/http/repositories/configuration/regulationtype'
import RegulationTypeModel from '@/shared/models/configuration/regulationtypemodel'
import RegulationTypeForms from './regulationtype-form'

export default {
  name: 'RegulationType',
  mixins: [ActionsForm],
  data () {
    return {
      data: RegulationTypeModel,
      form: RegulationTypeForms
    }
  },
  components: {
    Cfg
  },
  mounted () {
    this.onLoadAllArea()
    this.onLoadAllStage()
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.description.maxlength)
    }
  },
  methods: {
    onLoad () {
      loading.push()
      RegulationTypeRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onCreate () {
      loading.push()
      RegulationTypeRepository.Create(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      RegulationTypeRepository.Update(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDelete (obj) {
      loading.push()
      RegulationTypeRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllArea () {
      loading.push()
      AreaRepository.GetAll()
        .then((response) => {
          this.form.areaID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllStage () {
      loading.push()
      StageRepository.GetAll()
        .then((response) => {
          this.form.stageID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/regulationtype/regulationtype.js